// .pen ndI5h 弹框-排序筛选 — 客户端排序单一来源。
// 约定:文件夹永远分组在前(云盘惯例),order 只作用于组内 key 比较。

export type SortBy = 'created_at' | 'name' | 'size' | 'type'
export type SortOrder = 'asc' | 'desc'
export type SortState = { sortBy: SortBy; order: SortOrder }

export const DEFAULT_SORT: SortState = { sortBy: 'created_at', order: 'desc' }

export type SortableRow = {
  name: string
  type: string
  size?: number | null
  created_at: string
}

export function sortFileRows<T extends SortableRow>(
  rows: readonly T[],
  { sortBy, order }: SortState,
): T[] {
  const dir = order === 'asc' ? 1 : -1
  return [...rows].sort((a, b) => {
    const af = a.type === 'folder' ? 0 : 1
    const bf = b.type === 'folder' ? 0 : 1
    if (af !== bf) return af - bf
    let cmp: number
    if (sortBy === 'name') {
      cmp = a.name.localeCompare(b.name, 'zh-Hans-CN')
    } else if (sortBy === 'size') {
      cmp = (a.size ?? 0) - (b.size ?? 0)
    } else if (sortBy === 'type') {
      // type 同值回退 name;回退方向跟随 order(有意设计)
      cmp = a.type.localeCompare(b.type) || a.name.localeCompare(b.name, 'zh-Hans-CN')
    } else {
      cmp = a.created_at.localeCompare(b.created_at)
    }
    return cmp * dir
  })
}
